// src/lib/managers/graph/types/index.ts

export enum MailFolder {
    Inbox = "inbox",
    Archive = "archive",
    SentItems = "sentitems",
    Drafts = "drafts",
    JunkEmail = "junkemail",
    Deleteditems = "deleteditems",
}

export enum MailImportance {
    Low = "low",
    Normal = "normal",
    High = "high",
}

export enum MailFlagStatus {
    Flagged = "flagged",
    Complete = "complete",
}

export interface BatchRequestItem {
    id: string;
    method: string;
    url: string;
    body?: any;
    headers?: any;
}

export interface BatchRequestData {
    requests: BatchRequestItem[];
}

/**
 *  Profil utilisateur Graph
 */
export interface GraphUserProfile {
    id: string;
    displayName: string;
    givenName: string;
    surname: string;
    mail: string;
    userPrincipalName: string;
    mobilePhone: string;
    country: string;
    streetAddress: string;
    state: string;
    city: string;
    postalCode: string;
    photoUrl: string;
}
